import { debounce } from "lodash";
import { useLayoutEffect, useState } from "react";

const tabletBreakPoint = 768;

export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState(
    window.innerWidth < tabletBreakPoint,
  );

  useLayoutEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    const updateSize = (): void => {
      setIsMobile(window.innerWidth < tabletBreakPoint);
    };
    const debouncedUpdateSize = debounce(updateSize, 250);
    window.addEventListener("resize", debouncedUpdateSize);

    return (): void => {
      window.removeEventListener("resize", debouncedUpdateSize);
      debouncedUpdateSize.cancel();
    };
  }, []);

  return isMobile;
};
